// src/pages/auth/AuthShell.tsx
// Centred card with the Nexilink header, shared by the standalone auth pages
// (forgot password, reset password) so they read as one flow rather than three
// separately-invented screens.
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface AuthShellProps {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
}

export const AuthShell: React.FC<AuthShellProps> = ({ title, subtitle, children }) => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col bg-neutral-100">
            <header className="flex justify-center items-center px-6 py-4 w-full border-b bg-white">
                <img
                    loading="lazy"
                    src="/images/e937596a79e27aedd1ca37344ef2209cd6e8c5da2cc900e6c0f5467b6176325e.png"
                    alt="Nexilink"
                    className="w-[150px] sm:w-[206px] object-contain aspect-[2.61] cursor-pointer"
                    onClick={() => navigate('/')}
                />
            </header>

            <main className="flex-1 flex items-center justify-center px-4 py-10">
                <div className="w-full max-w-md bg-white rounded-2xl border-2 border-gray-100 shadow-sm overflow-hidden">
                    <div className="px-6 pt-6 pb-4 text-center">
                        <h1 className="text-lg font-bold text-[#212121]">{title}</h1>
                        {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
                    </div>
                    <div className="px-6 pb-6">{children}</div>
                </div>
            </main>

            <footer className="py-6 text-center text-xs text-gray-500">
                <p>© {new Date().getFullYear()} Nexilink. Alla rättigheter förbehållna.</p>
            </footer>
        </div>
    );
};
